export default "__VITE_ASSET__CoPibcgy__"